import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@welldev-group/react-comp-lib';
import Modal from '@welldev-group/rcl-modal';

const SubscriptionWaitingModal = ({ isVisible, waitingText }) => {
  return (
    <Modal className="subscription-waiting-modal" isVisible={isVisible}>
      <Modal.Content
        className="subscription-waiting-modal__body"
        align="center"
      >
        <Spinner color="success" bgColor="neutral" />
        <div className="subscription-waiting-modal__body-text">
          {waitingText}
        </div>
      </Modal.Content>
    </Modal>
  );
};

SubscriptionWaitingModal.defaultProps = {
  isVisible: false,
  waitingText: '',
};

SubscriptionWaitingModal.propTypes = {
  isVisible: PropTypes.bool,
  waitingText: PropTypes.string,
};

export default SubscriptionWaitingModal;
